import { Injectable, OnInit, signal, effect, EffectRef, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { SharedService } from './shared.service';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { localStorageService } from './localstorage.service';
import { SocketsService } from './socket.service';

@Injectable({
  providedIn: 'root',
})
export class MainService implements OnInit {
  public env = environment;
  // user_review_list = [];
  public ip_country_id = signal<any>([]);
  public timezones = signal<any>([]);
  public country_data = signal<any>([]);
  public stripeKey: any;
  private usStripeKey: any;
  private ukStripeKey: any;
  private caStripeKey: any;
  private readonly UK_COUNTRY_ID = 5;
  private readonly CA_COUNTRY_ID = 2;
  private stripeKeyEffectRef?: EffectRef;
  public dynamicColorBgStyle = [
    {
      bg: '#E1FDF3',
      color: '#0F6648',
    },
    {
      bg: '#FFC737',
      color: '#000',
    },
    {
      bg: '#FFEFF0',
      color: '#76012C',
    },
    {
      bg: '#E1FDF3',
      color: '#18B557',
    },
  ];
  randomIndex = Math.floor(
    Math.random() * (this.dynamicColorBgStyle.length - 1)
  );
  plansList: Array<[]> = [];

  countryWiseRegex = {
    US: {
      regex: /(\d{3})(\d{3})(\d{4})/g,
      group: '$1-$2-$3',
    },
    CA: {
      regex: /(\d{3})(\d{3})(\d{4})/g,
      group: '$1-$2-$3',
    },
    GB: {
      regex: /(\d{4})(\d{5})/g,
      group: '$1 $2',
    },
    AU: {
      regex: /(\d{1})(\d{4})(\d{4})/g,
      group: '$1 $2 $3',
    },
    NZ: {
      regex: /(\d{1})(\d{4})(\d{4})/g,
      group: '$1 $2 $3',
    },
    DE: {
      regex: /(\d{4})(\d{7})/g,
      group: '$1 $2',
    },
    IT: {
      regex: /(\d{3})(\d{7})/g,
      group: '$1 $2',
    },
    FR: {
      regex: /(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/g,
      group: '$1 $2 $3 $4 $5',
    },
    ES: {
      regex: /(\d{3})(\d{6})/g,
      group: '$1 $2',
    },
    PL: {
      regex: /(\d{3})(\d{3})(\d{3})/g,
      group: '$1 $2 $3',
    },
    JP: {
      regex: /(\d{2})(\d{4})(\d{4})/g,
      group: '$1 $2 $3',
    },
  };

  getsettings_count: number = 0;
  show_full_view: string | undefined;
  userHash: string | undefined;
  iscommercial : any;

  public path_redirect_to = '';
  doctor_profile: any;
  // public access_info: BehaviorSubject<any> = new BehaviorSubject('');

  constructor(
    private _local: localStorageService,
    private apiSer: ApiService,
    private _router: Router,
    public _shared: SharedService,
    private _socket: SocketsService,
    private injector: Injector
  ) {
    this.init();

    this._socket.consentSubject$.subscribe((data) => {
      if (data && data.doctor_id) {
        this.getConsentStatus()
      }
    });
  }

  ngOnInit(): void {}
  // google sign in decoding url
  // decodeJwtResponse(token: string) {
  //   const base64Url = token.split('.')[1];
  //   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  //   // tslint:disable-next-line:only-arrow-functions
  //   const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
  //     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  //   }).join(''));

  //   return JSON.parse(jsonPayload);
  // }

  // get google signin creden flow
  async getUserInfo(accessToken: string) {
    try {
      const response = await fetch(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const userInfo = await response.json();
      return userInfo;
    } catch (error) {
      console.error('Error fetching user info:', error);
      throw error; // You might want to handle or log the error accordingly
    }
  }

  registerUser(userInfoData: userInfo) {
    if (!userInfoData.country_id || !userInfoData.currency_id) {
      const data = this._shared.country_data();
      if (data && data.length) {
        userInfoData.country_id = data[0]['country_id'];
        userInfoData.currency_id = data[0]['currency'][0]['currency_id'];
      }
    }
    this.apiSer.api(userInfoData, 'auth/register').subscribe((data) => {
      if (data.is_error == 0) {
        this.checkProfile(data);
        // this._local.customSetItem('token', data.access_token);
        // this._router.navigate(['verify-login']);
      } else {
        // tslint:disable-next-line:quotemark
        this._shared.customPopups(data.original_text, 1);
      }
    });
  }

  // initialise function of reload or first time initialisation
  init() {
    this._shared.device_id();
    if (this._local.customGetItem('user')) {
      let data = {
        access_token: this._local.customGetItem('token'),
      };

      if (data.access_token && data.access_token != null) {
        this.accessTokenLogin();
        // this.listAllCards();
      }
      this.apiSer
        .api(data, 'auth/get_settings', 'get')
        .subscribe((response: any) => {
          if (response.flag === 70 || response.update_message) {
            location.reload();
            return false;
          }
          if (
            response &&
            (response.stripe_pk ||
              response.stripe_pk_uk ||
              response.stripe_pk_ca)
          ) {
            // get_settings now returns separate publishable keys per account:
            // stripe_pk (US/default), stripe_pk_uk (UK) and stripe_pk_ca (Canada).
            // Resolve the correct one based on the business country id.
            this.usStripeKey = response.stripe_pk;
            this.ukStripeKey = response.stripe_pk_uk;
            this.caStripeKey = response.stripe_pk_ca;
            this.applyStripeKeyByCountry();
            // above code moved to below functional and for new stripe functionality now below function will execute element
            // this.stripeCreateElem();
          }
          // Stripe.setPublishableKey(response.stripe_pk);
          // this.messageList = response.popups;
          // this.user_review_list.next(response.user_review_list); // Message List for how did you hear about us?
          // this.government_docs_main.next(response.government_docs); // Message List for how did you hear about us?
          // this.salutations.next(response.salutation);
          this.timezones.set(response.timezones);
          // this.arProposals.next(response.total_arv2_proposals);
          // if (response.preapproval_leads_object) {
          //   this.preapproval_leads_object.next(response.preapproval_leads_object);
          // }
          this.ip_country_id.set(response.ip_country_id);
          // if (response.mobile_code_arr && response.mobile_code_arr.length) {
          //   this.mobile_code_arr.set(response.mobile_code_arr);
          // }
          if (response.language_data && response.language_data.length) {
            this._shared.language_data.set(response.language_data);
          }
          if (response.country_data && response.country_data.length) {
            this._shared.country_data.set(response.country_data);
          }
          return true;
        });
    } else {
      this._shared.device_id();
    }
    this.Show_grid_full_view();
  }

  // Choose the Stripe publishable key based on the logged-in business country.
  // UK businesses (country_id === 5) use stripe_pk_uk, Canada businesses
  // (country_id === 2) use stripe_pk_ca; everyone else uses stripe_pk.
  private applyStripeKeyByCountry() {
    // Re-runs whenever country_currency_info() changes (it lands async after
    // login), picking the correct publishable key and pushing it to the shared
    // stripeKey signal. Destroy any previous effect so we don't stack them.
    this.stripeKeyEffectRef?.destroy();
    this.stripeKeyEffectRef = effect(
      () => {
        const info: any = this._shared.country_currency_info();
        const countryId = Number(info?.country?.country_id);
        let stripeKey = this.usStripeKey;
        if (countryId === this.UK_COUNTRY_ID && this.ukStripeKey) {
          stripeKey = this.ukStripeKey;
        } else if (countryId === this.CA_COUNTRY_ID && this.caStripeKey) {
          stripeKey = this.caStripeKey;
        }
        if (stripeKey) {
          this.stripeKey = stripeKey;
          this._shared.stripeKey.set(stripeKey);
        }
      },
      { injector: this.injector, allowSignalWrites: true }
    );
  }

  listAllCards() {
    this.apiSer
      .api({}, 'profile/list_all_cards', 'get')
      .subscribe((res: any) => {
        let cards = this._shared.sortByFun(res.data, 'is_default');
        let doctor_cards = cards; // doctor_cards is initially set with cards fetched through subscription details api. But on add new card here we setting it again so that new card can be set
        // this.cd.detectChanges();
        // console.log(doctor_cards, 'doctor_cards')
      });
  }

  Show_grid_full_view() {
    if (!this._local.customGetItem('show_full_view')) {
      this._local.customSetItem('show_full_view', 'false');
    }
    this.show_full_view = JSON.parse(
      JSON.stringify(this._local.customGetItem('show_full_view'))
    );
  }

  matchPassword(control: AbstractControl): ValidationErrors | null {
    const password = control.get('newPassword')?.value;
    const confirm = control.get('confirmPassword')?.value;
    if (password != confirm) {
      return { noMatch: true };
    }
    return null;
  }

  // getFinanceValues(docId: string, type?: string) {
  //   const data = {
  //     access_token: this._local.customGetItem('token'),
  //     doctor_id: docId,
  //     from_cache: 0,
  //     contract_type: type === 'tenPercent' ? 1 : type === 'inHouse' ? 3 : type === 'easyFinance' ? 4 : type === 'deferredPlan' ? 6 : 2
  //   };

  //   this.apiSer.api(data, `get_can_finance_status`)
  //     .subscribe(response => {
  //       if (response.is_error) {
  //         this.financeData.set(null);
  //         // this.customPopups(response.override_text, 1);
  //       } else {
  //         this._local.customSetItem('getFinanceValues', JSON.stringify(response));
  //         this._local.customSetItem('doctorProfile', JSON.stringify(response.data));
  //         this.financeData = response;
  //         this.financeData.set(response);
  //       }
  //     });
  // }

  checkProfile(userData: any, type?:any) {
    this._local.customSetItem('token', userData.access_token);
    if (userData.doctor_profile) {
      this._local.customSetItem('userProfileData', { ...userData.doctor_profile, user_hash_key: userData.user_hash_key });
      this._shared.doctorProfile.set(userData.doctor_profile);
    }
    if (
      userData &&
      (userData.mobile_required == 1 || userData.ind_id_required == 1)
    ) {
      this._router.navigate(['business-Info'], { queryParams: {type: type} });
    } else {

      console.log('Doctor login detected, redirecting to customer list',userData);
      //handling for agent login
        const roleId =
         userData?.doctor_profile?.role_id || userData?.role_id;

        if (roleId === 5) {
          this._shared.authenticateApiResponse.set(userData);
          this._shared.initIntercom();
          // Ensure agents also receive all shared data used by components (country_currency_info, debt_owed_duration_and_discount, etc.)
          this.assignDetails(userData, false);
          
          console.log('Agent login detected, redirecting to customer list',userData);
          // Agents need duration_list for discount calculation - fetch it separately if not in response
          if (!userData.debt_owed_duration_and_discount) {
            this.apiSer.api({}, 'finance/get_debt_owed_duration_and_discount', 'get').subscribe((res: any) => {
              if (res && res.debt_owed_duration_and_discount) {
                this._shared.debt_owed_duration_and_discount.set(res.debt_owed_duration_and_discount);
              }
            });
          }
          
          this._router.navigateByUrl('/app/customer/list');
          return; 
        }
        
      if (userData && userData.doctor_settings) {
        this._local.customSetItem('doctorSettings', userData.doctor_settings);
      }
      this.doctor_profile = this._local.customGetItem('userProfileData');
      this._shared.authenticateApiResponse.set(userData);
      this._shared.initIntercom();
      this.assignDetails(userData, true);
    }
  }

  assignDetails(response: any, redirectDashboard: boolean) {
    if (response.country_currency_info) {
      if (
        response.country_currency_info &&
        response.country_currency_info.country
      ) {
        this._shared.country_currency_info.set(
          response.country_currency_info
        );
      }
    }

    // doctor_settings comes back as 0 when there is no settings row, so read the rates
    // defensively -- this used to throw and abort the rest of assignDetails
    const debt_collection_rates = response?.doctor_settings?.debt_collection_rates;
    if (response.debt_owed_duration_and_discount && !debt_collection_rates) {
      this._shared.debt_owed_duration_and_discount.set(
        response.debt_owed_duration_and_discount
      );
    } else if (debt_collection_rates) {
      this._shared.debt_owed_duration_and_discount.set(
        JSON.parse(debt_collection_rates)
      );
    }
    
    if (response.bank_details) {
      this._shared.bank_details.set(response.bank_details);
    }
    if (response.auth_docs) {
      this._shared.auth_docs.set(response.auth_docs);
    }
    if (
      response.stripe_data &&
      response.stripe_data.verification &&
      response.stripe_data.verification.status
    ) {
      this._shared.identity_status.set(
        response?.doctor_profile?.business_verification_state
      );
    }
    if (response.doctor_settings) {
      this._local.customSetItem('doctorSettings', response.doctor_settings);
      this._shared.doctorSettings.set(response.doctor_settings);
    }

    this._socket.disconnect();
    if (response?.menu?.length) {
      this._local.customSetItem('menu', response.menu);
    }

    this._socket.connect();
    if (redirectDashboard) {
      if (
        response.menu &&
        response.menu.length > 0 &&
        response.menu.filter((menu: any) => menu.path.includes('dashboard'))
          .length == 0
      ) {
        this._router.navigate(['app', 'finance', 'payment-plans']);
      } else {
        this._router.navigate(['app', 'dashboard']);
      }
      this._shared.setClarity();
    } else {
      if (
        response.menu &&
        response.menu.length > 0 &&
        response.menu.filter((menu: any) => menu.path.includes('dashboard'))
          .length == 0
      ) {
        // this.is_from_login = true;
        this._router.navigate(['app', 'finance', 'payment-plans']);
      } else {
        if (
          window.location.pathname.includes('business-info') ||
          window.location.pathname.includes('verify-phone-number')
        ) {
          this._router.navigate(['app', 'dashboard']);
          this._shared.setClarity();
        }
      }
    }
  }

  accessTokenLogin() {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments[0] === 'receipt' && pathSegments[1]) {
      return;
    }
    this.apiSer
      .api({}, 'auth/access_token_login')
      .subscribe((response: any) => {
        if (response.flag === 116) {
          this._local.customSetItem(
            'reset_password_token',
            response.reset_password_token
          );
          this._router.navigate(['new-password']);
        } else if (!response.is_error) {
          if (response['redirectUrl'] && response['redirectUrl'].url) {
            this._router.navigate([response['redirectUrl'].url], {
              queryParams: response['redirectUrl'].query,
            });
          } else {
            // proceed to dashboard
            if (response.doctor_profile) {
              const doctorDebtType = Number(response.doctor_profile.doctor_debt_type ?? response.doctor_profile.debt_type);
              this.iscommercial = [0, 1, 2, 3].includes(doctorDebtType) ? doctorDebtType : 1;
              this._local.customSetItem(
                'userProfileData',
                { ...response.doctor_profile, user_hash_key: response.user_hash_key }
              );
              this.doctor_profile = this._local.customGetItem('userProfileData');
              this._shared.doctorProfile.set(response.doctor_profile);
              this._local.customSetItem('e_consent_status',response.doctor_profile.e_consent_status);
              let e_con = this._local.customGetItem('e_consent_status');
            }

            const roleId = response?.doctor_profile?.role_id || response?.role_id;

            if (roleId == 5) {
              this._shared.initIntercom();
              if (response.user_hash) {
                this.userHash = response.user_hash;
              }
              // Set this first, same order as the fresh-login path: the sidemenu reads its menus
              // off this signal, so it must not depend on assignDetails getting to the end
              this._shared.authenticateApiResponse.set(response);

              //populate shared subjects just like doctor
              this.assignDetails(response, false);

              return;
            }

            this._local.customSetItem(
              'debt_duration',
              response.ar_v2_debt_owed_duration
            );
            // if user has just registered but not completed all steps then first check mobile validation then industry validation
            if (response.mobile_required || response.ind_id_required == 1) {
              this._router.navigate(['business-info']);
              return;
            } else {
              this._shared.initIntercom();
              this.assignDetails(response, false);
            }
          }
          if (response.user_hash) {
            this.userHash = response.user_hash;
          }
          this._shared.authenticateApiResponse.set(response);
        } else {
          // If API call fails or token is invalid, redirect to login
          this._local.customClearAllItems();
          this._router.navigate(['/login']);
        }
      }, (error) => {
        // Handle HTTP errors
        this._local.customClearAllItems();
        this._router.navigate(['/login']);
      });
  }

  public consentData = signal<any>(null);

  getConsentStatus() {
    this.apiSer.api({}, 'profile/get_consent_status', 'get')
      .subscribe((res) => {
        this.consentData.set(res.data);
      })
  }

}

export interface userInfo {
  doctor_email: string;
  doctor_password: string;
  doctor_name: string;
  country_id: number;
  currency_id: number;
  doctor_image: any;
  google_id?: string;
  /** base64 capture of the screen at legal acceptance; uploaded to S3 by the API */
  legal_consent?: string | null;
}
